import { WSAlert, WSMarginProps } from "@wingspanhq/fe-component-library";
import { useFeatureFlags } from "../../../../query/hooks/useFeatureFlags";
import { openInNewTab } from "../../../../shared/utils/openInNewTab";
import { WS_LINKS } from "../../../../types/wsLinks";

interface Props extends WSMarginProps {}

export const TAX_FILING_ALERT_VERIFICATION_PENDING_COPY =
  "Tax ID verifications will resume by October 1st, 2025 after upgrades are complete.";
export const TAX_FILING_ALERT_VERIFICATION_PENDING_TITLE =
  "Verification pending";

export const AlertTaxFilingVerificationPending: React.FC<Props> = ({
  ...otherProps
}) => {
  const queryFeatureFlags = useFeatureFlags();

  if (queryFeatureFlags.data?.is1099FilingPaused === true) {
    return (
      <WSAlert
        theme="info"
        size="M"
        icon="info-circle"
        title={TAX_FILING_ALERT_VERIFICATION_PENDING_TITLE}
        action={{
          onClick: () => {
            openInNewTab(WS_LINKS.taxFilingPause);
          },
          text: "Learn more"
        }}
        {...otherProps}
      >
        {TAX_FILING_ALERT_VERIFICATION_PENDING_COPY}
      </WSAlert>
    );
  }
  return null;
};
